(() => {
  const configElement = document.getElementById('GooseJohnModelGallery');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const imageSelector = 'img[src*="john-cafe-oscuro-modelo-"]';
  let lastVariant;
  let sizeGuide;
  const section = () => document.querySelector('[id^="MainProduct-"]');
  const textureColorSwatches = () => {
    if (!config.isHat) return;
    const options = section()?.querySelectorAll(`.globo-swatch-product-detail [data-option-index="${config.colorIndex}"] li[data-value]`);
    options?.forEach((option) => {
      const swatch = config.swatches?.find((item) => item.color === option.dataset.value);
      const label = option.querySelector('label');
      if (!swatch?.texture || !label) return;
      const texture = 'url(' + JSON.stringify(swatch.texture) + ')';
      if (label.style.getPropertyValue('--goose-color-texture') !== texture) {
        label.style.setProperty('--goose-color-texture', texture);
      }
      label.classList.add('goose-john-textured-swatch');
      label.classList.toggle('goose-john-textured-swatch--tinted', swatch.tinted);
    });
  };
  const featuredCollection = (item) => item.handle === 'mas-vendidos' || item.handle.includes('favorit');
  const collectionLabels = () => {
    const collections = config.collections || [];
    let origin = collections.find((item) => item.handle === config.collectionHandle);
    if (!origin && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === location.origin) {
          const handle = referrer.pathname.match(/\/collections\/([^/]+)/)?.[1];
          origin = collections.find((item) => item.handle === handle);
        }
      } catch {}
    }
    const primary = collections.find((item) => item.handle.startsWith('coleccion-inspirada-')) ||
      collections.find((item) => !featuredCollection(item) && !['all', 'ver-todos', 'entrega-inmediata', 'hot-sale', 'frontpage'].includes(item.handle));
    return [origin, primary, ...collections.filter(featuredCollection)]
      .filter((item, index, items) => item && items.findIndex((entry) => entry?.handle === item.handle) === index);
  };
  const labels = collectionLabels();
  const positionCollectionLabels = (info) => {
    const vendor = info.querySelector(':scope > .product__text.caption-with-letter-spacing');
    if (!vendor) return;
    vendor.classList.add('goose-john-vendor-replaced');
    if (!labels.length || info.querySelector('.goose-john-collection-labels')) return;
    const navigation = document.createElement('nav');
    navigation.className = 'goose-john-collection-labels';
    navigation.setAttribute('aria-label', config.collectionsLabel);
    labels.forEach((item) => {
      const link = document.createElement('a');
      link.className = 'goose-john-collection-label';
      if (featuredCollection(item)) link.classList.add('goose-john-collection-label--featured');
      link.href = item.url;
      link.textContent = item.title;
      link.dataset.collectionHandle = item.handle;
      navigation.append(link);
    });
    vendor.before(navigation);
  };
  const positionProductHeading = () => {
    const info = section()?.querySelector('product-info[id^="ProductInfo-"]');
    if (!info) return;
    positionCollectionLabels(info);
    const title = info.querySelector(':scope > .product__title, .goose-john-title-row > .product__title');
    const price = info.querySelector('[id^="price-"]');
    if (!title || !price) return;
    let heading = info.querySelector('.goose-john-heading');
    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'goose-john-heading';
      const row = document.createElement('div');
      row.className = 'goose-john-title-row';
      title.before(heading);
      heading.append(row);
      row.append(title, price);
    }
    const rating = info.querySelector(':scope > .rating');
    if (rating) {
      let reviews = heading.querySelector('.goose-john-reviews');
      if (!reviews) {
        reviews = document.createElement('div');
        reviews.className = 'goose-john-reviews';
        const stars = document.createElement('div');
        stars.className = 'goose-john-stars';
        const link = document.createElement('a');
        link.className = 'goose-john-review-link';
        link.href = '#judgeme_product_reviews';
        link.textContent = config.viewReviews;
        reviews.append(stars, link);
        heading.append(reviews);
      }
      const stars = reviews.querySelector('.goose-john-stars');
      stars.replaceChildren(...info.querySelectorAll(':scope > .rating, :scope > .rating-text, :scope > .rating-count'));
    }
  };
  const positionSizeGuide = () => {
    const root = section();
    const sizes = root?.querySelector(`.globo-swatch-product-detail .swatch--gl[data-option-index="${config.sizeIndex}"]`);
    if (!sizes) return;
    const existing = root.querySelector('details[id^="Details-collapsible_tab_VfTimn-"]');
    sizeGuide = existing?.closest('.product__accordion') || sizeGuide;
    sizes.dataset.gooseSizeOption = '';
    const legend = sizes.querySelector('legend.name-option');
    if (!legend || !document.getElementById('GooseSizeGuideTemplate')) return;
    let header = sizes.querySelector('.goose-john-size-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'goose-john-size-header';
      const link = document.createElement('a');
      link.className = 'goose-john-size-link';
      link.href = '#GooseSizeGuide';
      link.textContent = config.sizeGuide;
      link.dataset.gooseSizeGuideOpen = '';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', 'GooseSizeGuide');
      link.setAttribute('aria-expanded', 'false');
      sizes.prepend(header);
      header.append(legend, link);
    }
    const label = [...legend.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    if (label && label.textContent.trim() !== config.selectSize) label.textContent = config.selectSize + ' ';
    sizeGuide?.classList.add('goose-john-size-guide', 'goose-john-size-guide--inline-source');
  };
  const positionMaterialGuide = () => {
    const root = section();
    const materials = root?.querySelector(`.globo-swatch-product-detail .swatch--gl[data-option-index="${config.materialIndex}"]`);
    const legend = materials?.querySelector('legend.name-option');
    if (!legend || !document.getElementById('GooseMaterialGuideTemplate')) return;
    let header = materials.querySelector('.goose-john-material-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'goose-john-size-header goose-john-material-header';
      const link = document.createElement('a');
      link.className = 'goose-john-size-link goose-john-material-link';
      link.href = '#GooseMaterialGuide';
      link.textContent = config.materialGuide;
      link.dataset.gooseMaterialGuideOpen = '';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', 'GooseMaterialGuide');
      link.setAttribute('aria-expanded', 'false');
      materials.prepend(header);
      header.append(legend, link);
    }
    const label = [...legend.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    if (label && label.textContent.trim() !== config.selectMaterial) label.textContent = config.selectMaterial + ' ';
    if (document.getElementById('GooseBeaverWaitlistTemplate') && !materials.querySelector('.goose-john-beaver-link')) {
      const link = document.createElement('a');
      link.className = 'goose-john-beaver-link';
      link.href = '#GooseBeaverWaitlist';
      link.textContent = config.beaverWaitlist;
      link.dataset.gooseBeaverWaitlistOpen = '';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', 'GooseBeaverWaitlist');
      link.setAttribute('aria-expanded', 'false');
      materials.append(link);
      root.querySelector('details[id^="Details-collapsible_tab_f3pBkW-"]')?.closest('.product__accordion')?.classList.add('goose-john-size-guide--inline-source');
    }
    root.querySelector('details[id^="Details-collapsible_tab_JVxDMn-"]')?.closest('.product__accordion')?.classList.add('goose-john-size-guide--inline-source');
  };
  const internationalShippingLink = () => {
    const paragraphs = section()?.querySelectorAll('.ns-edd-product-page .ql-editor p');
    paragraphs?.forEach((paragraph) => {
      if (paragraph.querySelector('.goose-john-international-link')) return;
      const text = paragraph.textContent.replace(/\uFEFF/g, '').trim();
      if (text !== 'Para envíos internacionales, el costo se cotiza por separado.') return;
      const link = document.createElement('a');
      link.className = 'goose-john-international-link';
      link.href = 'https://wa.me/527223538434?text=' + encodeURIComponent(config.internationalShippingMessage);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = config.internationalShipping;
      paragraph.replaceChildren(link);
    });
  };
  const positionDeliveryEstimate = () => {
    const root = section();
    const button = root?.querySelector('product-form .product-form__submit');
    const paragraphs = [...(root?.querySelectorAll('.ns-edd-product-page .ql-editor p') || [])];
    const source = paragraphs.find((paragraph) => /(?:Recibe\b|receive\b|free shipping.*Mexico)/i.test(paragraph.textContent));
    let banner = root?.querySelector('.goose-john-delivery');
    const sourceText = source?.textContent.trim() || '';
    const range = sourceText.match(/\b(?:entre|between)\s+(.+)$/i);
    const single = sourceText.match(/\b(?:el|on)\s+(.+)$/i);
    const dates = range ? config.deliveryBetween + ' ' + range[1] : single ? config.deliveryOn + ' ' + single[1] : '';
    if (!button || !source || !dates) {
      banner?.remove();
      paragraphs.forEach((paragraph) => paragraph.classList.remove('goose-john-delivery-source'));
      return;
    }
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'goose-john-delivery';
      banner.innerHTML = '<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h11v11H8m6-8h4l3 4v4h-3M1 9h6M1 12h4M3 15h2"/><circle cx="6.5" cy="17.5" r="2"/><circle cx="16.5" cy="17.5" r="2"/></svg><div><span class="goose-john-delivery__estimate"></span><span class="goose-john-delivery__shipping"></span></div>';
    }
    if (button.previousElementSibling !== banner) button.before(banner);
    const estimate = banner.querySelector('.goose-john-delivery__estimate');
    const text = config.orderToday + ' ' + dates;
    if (estimate.textContent !== text) estimate.textContent = text;
    const shipping = banner.querySelector('.goose-john-delivery__shipping');
    const shippingText = /envío gratis|free shipping/i.test(sourceText) ? config.freeShipping : '';
    if (shipping.textContent !== shippingText) shipping.textContent = shippingText;
    if (!banner.querySelector('.goose-john-express-link')) {
      const link = document.createElement('a');
      link.className = 'goose-john-express-link';
      link.href = 'https://wa.me/527223538434?text=' + encodeURIComponent(config.expressShippingMessage);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = config.expressShipping;
      shipping.after(link);
    }
    source.classList.add('goose-john-delivery-source');
  };
  const positionBenefits = () => {
    const root = section();
    const button = root?.querySelector('product-form .product-form__submit');
    const template = document.getElementById('GooseJohnBenefitsTemplate');
    if (!button || !template) return;
    let strip = root.querySelector('.goose-john-benefits');
    if (!strip) {
      strip = template.content.firstElementChild.cloneNode(true);
      const toggle = strip.querySelector('button');
      toggle.addEventListener('click', () => {
        const paused = strip.dataset.paused !== 'true';
        strip.dataset.paused = String(paused);
        toggle.setAttribute('aria-pressed', String(paused));
      });
    }
    if (button.nextElementSibling !== strip) button.after(strip);
    const info = root.querySelector('product-info');
    info?.querySelector(':scope > .icon-with-text')?.classList.add('goose-john-benefits-source');
    info?.querySelectorAll(':scope > p.product__text').forEach((paragraph) => {
      if (paragraph.textContent.includes('3, 6, 9 y 12 MSI')) paragraph.classList.add('goose-john-benefits-source');
    });
  };
  const stylePaymentMethods = () => {
    const info = section()?.querySelector('product-info');
    if (!info) return;
    const row = [...info.children].find((element) => {
      const logos = element.querySelectorAll(':scope > svg');
      return logos.length === 5 && element.textContent.includes('VISA') && element.textContent.includes('OXXO');
    });
    if (!row || row.classList.contains('goose-john-payment-methods')) return;
    row.classList.add('goose-john-payment-methods');
    const names = ['Visa', 'Mastercard', 'PayPal', 'Mercado Pago', 'OXXO'];
    row.querySelectorAll(':scope > svg').forEach((logo, index) => {
      logo.setAttribute('role', 'img');
      logo.setAttribute('aria-label', names[index]);
      logo.setAttribute('focusable', 'false');
    });
  };
  const selectedId = () => {
    const root = section();
    const field = root?.querySelector('product-form form input[name="id"]') ||
      root?.querySelector('form[action*="/cart/add"] [name="id"]');
    return String(field?.value || new URLSearchParams(location.search).get('variant') || config.initialVariant);
  };
  const positionStorySpecifications = () => {
    const copy = section()?.querySelector('[data-goose-original-description]');
    if (!copy || copy.dataset.specificationsReady) return;
    copy.dataset.specificationsReady = 'true';
    const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().replace(/[:.]$/, '').toLowerCase();
    const isHeading = (text) => /^(materiales(?: y detalles)?(?: destacados)?|especificaciones(?: tecnicas)?|technical specifications|caracteristicas(?: tecnicas)?|detalles del producto)$/.test(normalize(text));
    copy.querySelectorAll('[style]').forEach((element) => {
      if (!element.matches('img, video, iframe')) element.removeAttribute('style');
    });
    let heading = [...copy.querySelectorAll('h2,h3,h4,h5,h6,p,strong,b,em,span')].find((element) => isHeading(element.textContent));
    if (heading) {
      while (heading.parentElement !== copy && heading.parentElement && isHeading(heading.parentElement.textContent)) heading = heading.parentElement;
    } else {
      heading = [...copy.querySelectorAll('p,li')].find((element) => /^(?:material|copa|ala|ancho|alto|altura|medidas|tallas?)\s*:/i.test(element.textContent.trim()) && element.textContent.length < 240);
    }
    if (!heading) return;
    const range = document.createRange();
    range.setStartBefore(heading);
    range.setEnd(copy, copy.childNodes.length);
    const content = range.extractContents();
    const lines = [];
    let line = document.createDocumentFragment();
    const flush = () => {
      if (line.textContent.trim() || line.querySelector('img,video,iframe,table')) lines.push(line);
      line = document.createDocumentFragment();
    };
    const walk = (node, wrappers = []) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let fragment = node.cloneNode();
        [...wrappers].reverse().forEach((wrapper) => {
          const clone = wrapper.cloneNode(false);
          clone.append(fragment);
          fragment = clone;
        });
        line.append(fragment);
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
      if (node.nodeName === 'BR') { flush(); return; }
      if (/^(IMG|VIDEO|IFRAME|TABLE)$/.test(node.nodeName)) { flush(); line.append(node.cloneNode(true)); flush(); return; }
      const block = /^(P|DIV|SECTION|LI|UL|OL|H[1-6]|BLOCKQUOTE)$/.test(node.nodeName);
      if (block) flush();
      const inline = node.nodeType === Node.ELEMENT_NODE && !block;
      [...node.childNodes].forEach((child) => walk(child, inline ? [...wrappers, node] : wrappers));
      if (block) flush();
    };
    walk(content);
    flush();
    const removePrefix = (fragment, length) => {
      if (!length) return;
      const walker = document.createTreeWalker(fragment, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (length <= node.textContent.length) {
          const prefix = document.createRange();
          prefix.setStart(fragment, 0);
          prefix.setEnd(node, length);
          prefix.deleteContents();
          return;
        }
        length -= node.textContent.length;
      }
    };
    const specifications = document.createElement('div');
    specifications.className = 'goose-john-story__specs';
    const title = document.createElement('h3');
    title.textContent = document.documentElement.lang.startsWith('en') ? 'Technical specifications' : 'Especificaciones técnicas';
    const list = document.createElement('dl');
    const notes = [];
    lines.forEach((fragment) => {
      if (isHeading(fragment.textContent)) return;
      if (fragment.querySelector('img,video,iframe,table')) { notes.push(fragment); return; }
      const leading = fragment.textContent.match(/^[\s•\-]*/)[0].length;
      removePrefix(fragment, leading);
      const text = fragment.textContent.trimEnd();
      if (!text) return;
      const colon = text.match(/^([^:]{1,60}):\s*(?=\S)/);
      const named = text.match(/^(copa|ala|toquilla|tejido|material|forro|tafilete|herraje|incluye|estructura|ancho|alto|altura|proceso)\s+/i);
      let label;
      if (colon || named) {
        const match = colon || named;
        label = match[1].replace(/\s+/g, ' ').trim();
        removePrefix(fragment, match[0].length);
      } else if (/^(?:elaborad[oa]|hech[oa])\b/i.test(text)) {
        label = document.documentElement.lang.startsWith('en') ? 'Craftsmanship' : 'Elaboración';
      }
      if (!label || !fragment.textContent.trim()) { notes.push(fragment); return; }
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const definition = document.createElement('dd');
      term.textContent = label;
      definition.append(fragment);
      row.append(term, definition);
      list.append(row);
    });
    specifications.append(title);
    if (list.children.length) specifications.append(list);
    notes.forEach((fragment) => {
      const paragraph = document.createElement('p');
      paragraph.append(fragment);
      specifications.append(paragraph);
    });
    copy.querySelectorAll('p,div,span').forEach((element) => {
      if (!element.textContent.trim() && !element.querySelector('img,video,iframe')) element.remove();
    });
    copy.after(specifications);
  };
  const sync = (force = false) => {
    positionDeliveryEstimate();
    positionBenefits();
    stylePaymentMethods();
    internationalShippingLink();
    textureColorSwatches();
    positionProductHeading();
    positionStorySpecifications();
    positionSizeGuide();
    positionMaterialGuide();
    if (config.sizeIndex < 0) section()?.querySelector('details[id^="Details-collapsible_tab_VfTimn-"]')?.closest('.product__accordion')?.classList.add('goose-john-size-guide--inline-source');
    if (config.materialIndex < 0) section()?.querySelector('details[id^="Details-collapsible_tab_JVxDMn-"]')?.closest('.product__accordion')?.classList.add('goose-john-size-guide--inline-source');
    if (!document.getElementById('GooseBeaverWaitlistTemplate')) section()?.querySelector('details[id^="Details-collapsible_tab_f3pBkW-"]')?.closest('.product__accordion')?.classList.add('goose-john-size-guide--inline-source');
    section()?.setAttribute('data-goose-product-ready', '');
    const id = selectedId();
    if (config.isCody && config.variants[id]?.sku?.includes('-GRN-')) {
      const replacement = section()?.querySelector(`.globo-swatch-product-detail [data-option-index="${config.colorIndex}"] li[data-value="Tabaco"]`);
      if (replacement && !replacement.querySelector('input')?.checked) replacement.querySelector('label')?.click();
      return;
    }
    if (!force && id === lastVariant) return;
    lastVariant = id;
    const variant = config.variants[id];
    const joanBuckskin = config.isJoan && variant?.sku?.includes('-BUC-');
    const joanNegro = config.isJoan && variant?.sku?.includes('-NEG-');
    document.documentElement.dataset.gooseJoanBuckskin = joanBuckskin ? 'visible' : 'hidden';
    document.documentElement.dataset.gooseJoanNegro = joanNegro ? 'visible' : 'hidden';
    if (config.isJoan) {
      if (joanNegro) section()?.querySelectorAll('media-gallery video').forEach(video => video.pause());
    }
    const codyTabaco = config.isCody && variant?.sku?.includes('-TAB-');
    const codyNegro = config.isCody && variant?.sku?.includes('-NEG-');
    document.documentElement.dataset.gooseCodyNegro = codyNegro ? 'visible' : 'hidden';
    const codyBuckskin = config.isCody && variant?.sku?.includes('-BUC-');
    document.documentElement.dataset.gooseCodyBuckskin = codyBuckskin ? 'visible' : 'hidden';
    document.documentElement.dataset.gooseCodyTabaco = codyTabaco ? 'visible' : 'hidden';
    document.documentElement.dataset.gooseGovernorBlack = config.isGovernor && variant?.sku?.includes('-NEG-') ? 'visible' : 'hidden';
    const wheelerBlack = config.isWheeler && variant?.sku?.includes('-NEG-');
    document.documentElement.dataset.gooseWheelerBlack = wheelerBlack ? 'visible' : 'hidden';
    document.documentElement.dataset.gooseWheelerBrown = config.isWheeler && variant?.sku?.includes('-CFO-') ? 'visible' : 'hidden';
    const visible = variant?.show === true;
    const buckskin = config.isJohn && variant?.buckskin === true;
    document.documentElement.dataset.gooseJohnBuckskin = buckskin ? 'visible' : 'hidden';
    const black = config.isJohn && variant?.black === true;
    document.documentElement.dataset.gooseJohnBlack = black ? 'visible' : 'hidden';
    const snow = config.isJohn && variant?.snow === true;
    document.documentElement.dataset.gooseJohnSnow = snow ? 'visible' : 'hidden';
    const gray = config.isJohn && variant?.gray === true;
    document.documentElement.dataset.gooseJohnGray = gray ? 'visible' : 'hidden';
    document.documentElement.dataset.gooseJohnModels = visible ? 'visible' : 'hidden';
    const root = section();
    root?.querySelectorAll('media-gallery').forEach((gallery) => {
      const active = gallery.querySelector('.product__media-item.is-active');
      const items = [...gallery.querySelectorAll('.product__media-item[data-media-id]')];
      const primary = items.find((item) => variant?.media && item.dataset.mediaId.endsWith(`-${variant.media}`));
      if (config.isJoan && primary) {
        const colorPrefix = joanNegro ? 'joan-negro-' : 'joan-buckskin-';
        const filenames = [
          'posterior-sin-pluma-sin-logo', 'detalle-herraje', 'detalle-interior',
          'modelo-estudio-hombre', 'modelo-estudio-mujer', 'modelo-lifestyle-hombre', 'modelo-lifestyle-mujer'
        ];
        const filename = item => item.querySelector('img')?.src.split('/').pop().split('?')[0];
        const videos = joanBuckskin ? items.filter(item => item.querySelector('deferred-media, video, iframe')) : [];
        const ordered = [primary, ...filenames.map(name => items.find(item => filename(item)?.startsWith(colorPrefix + name))), ...videos].filter(Boolean);
        const list = gallery.querySelector('[id^="Slider-Gallery"]');
        const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
        [...ordered].reverse().forEach(item => {
          list?.prepend(item);
          const thumbnail = thumbnails.find(thumb => thumb.dataset.target === item.dataset.mediaId);
          if (thumbnail) thumbnail.parentElement.prepend(thumbnail);
        });
        gallery.johnScroll?.refresh();
        gallery.setActiveMedia?.(primary.dataset.mediaId, false);
        gallery.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
        return;
      }
      if (config.isJohnGift && primary) {
        gallery.setAttribute('data-goose-gift-gallery', '');
        const color = Object.keys(config.giftPhotos).find(code => variant.sku?.includes('-' + code + '-'));
        const filenames = config.giftPhotos[color] || [];
        const filename = item => item.querySelector('img')?.src.split('/').pop().split('?')[0];
        const toquilla = items.find(item => filename(item) === 'john-toquilla-de-regalo-3935176.png');
        const ordered = [primary, toquilla, ...filenames.map(name => items.find(item => filename(item) === name))].filter(Boolean);
        const allowed = new Set(ordered);
        items.forEach(item => {
          item.classList.toggle('goose-gift-visible', allowed.has(item));
          item.classList.toggle('goose-gift-hidden', !allowed.has(item));
        });
        const thumbs = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
        thumbs.forEach(thumb => {
          const visible = ordered.some(item => item.dataset.mediaId === thumb.dataset.target);
          thumb.classList.toggle('goose-gift-visible', visible);
          thumb.classList.toggle('goose-gift-hidden', !visible);
        });
        const list = gallery.querySelector('[id^="Slider-Gallery"]');
        [...ordered].reverse().forEach(item => {
          list?.prepend(item);
          const thumb = thumbs.find(t => t.dataset.target === item.dataset.mediaId);
          if (thumb) thumb.parentElement.prepend(thumb);
        });
        gallery.johnScroll?.refresh();
        gallery.setActiveMedia?.(primary.dataset.mediaId, false);
        gallery.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
        return;
      }
      if (codyBuckskin && primary) {
        const filenames = [
          'cody-j-buckskin-vista-frontal',
          'cody-j-buckskin-vista-lateral',
          'cody-j-buckskin-vista-superior',
          'cody-j-buckskin-detalle-herraje',
          'cody-j-buckskin-modelo-estudio-hombre',
          'cody-j-buckskin-modelo-estudio-mujer',
          'cody-j-buckskin-modelo-lifestyle-hombre',
          'cody-j-buckskin-modelo-lifestyle-mujer',
        ];
        const filename = item => item.querySelector('img')?.src.split('/').pop().split('?')[0];
        const ordered = [primary, ...filenames.map(name => items.find(item => filename(item)?.startsWith(name)))].filter(Boolean);
        const list = gallery.querySelector('[id^="Slider-Gallery"]');
        const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
        [...ordered].reverse().forEach(item => {
          list?.prepend(item);
          const thumbnail = thumbnails.find(thumb => thumb.dataset.target === item.dataset.mediaId);
          if (thumbnail) thumbnail.parentElement.prepend(thumbnail);
        });
      }
      if (codyNegro && primary) {
        const filenames = [
          'cody-j-negro-vista-frontal',
          'cody-j-negro-vista-lateral',
          'cody-j-negro-vista-superior',
          'cody-j-negro-detalle-herraje',
          'cody-j-negro-modelo-estudio-hombre',
          'cody-j-negro-modelo-estudio-mujer',
          'cody-j-negro-modelo-lifestyle-hombre',
          'cody-j-negro-modelo-lifestyle-mujer',
        ];
        const filename = item => item.querySelector('img')?.src.split('/').pop().split('?')[0];
        const ordered = [primary, ...filenames.map(name => items.find(item => filename(item)?.startsWith(name)))].filter(Boolean);
        const list = gallery.querySelector('[id^="Slider-Gallery"]');
        const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
        [...ordered].reverse().forEach(item => {
          list?.prepend(item);
          const thumbnail = thumbnails.find(thumb => thumb.dataset.target === item.dataset.mediaId);
          if (thumbnail) thumbnail.parentElement.prepend(thumbnail);
        });
      }
      if ((gray || buckskin || black || snow || wheelerBlack || codyBuckskin || codyNegro) && primary) {
        const list = gallery.querySelector('[id^="Slider-Gallery"]');
        if (list && list.firstElementChild !== primary) list.prepend(primary);
        const thumbnail = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')].find((item) => item.dataset.target === primary.dataset.mediaId);
        if (thumbnail && thumbnail.parentElement.firstElementChild !== thumbnail) thumbnail.parentElement.prepend(thumbnail);
      }
      gallery.johnScroll?.refresh();
      if (gray || buckskin || black || snow || wheelerBlack || codyBuckskin || codyNegro || active?.getBoundingClientRect().width === 0 || (!visible && active?.querySelector(imageSelector))) {
        const next = primary || items.find((item) => item.getBoundingClientRect().width > 0);
        if (next && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(next.dataset.mediaId, false);
      }
      gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
    });
    const modal = document.querySelector('product-modal[open]');
    if (!joanBuckskin && modal?.querySelector('img[src*="joan-buckskin-modelo-"].active')) modal.hide?.();
    if (config.isJoan && modal && (joanNegro ? !modal.querySelector('img[src*="joan-negro-"].active') : modal.querySelector('img[src*="joan-negro-"].active'))) modal.hide?.();
    if (!codyBuckskin && modal?.querySelector('img[src*="cody-j-buckskin-"].active')) modal.hide?.();
    if (!codyNegro && modal?.querySelector('img[src*="cody-j-negro-"].active')) modal.hide?.();
    if (!codyTabaco && modal?.querySelector('img[src*="cody-j-tabaco-modelo-"].active')) modal.hide?.();
    if (!visible && modal?.querySelector(`${imageSelector}.active`)) modal.hide?.();
  };
  const schedule = () => {
    sync();
    requestAnimationFrame(() => sync());
    setTimeout(() => sync(), 80);
    setTimeout(() => sync(), 300);
  };
  document.addEventListener('change', (event) => {
    if (section()?.contains(event.target)) schedule();
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.goose-john-review-link')) return;
    setTimeout(() => {
      document.getElementById('judgeme_product_reviews')?.scrollIntoView({ block: 'start', behavior: 'auto' });
    }, 600);
  });
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', () => sync(true));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }
  setInterval(() => { if (!document.hidden) sync(); }, 250);
  sync(true);
})();





